import React from "react";
import styles from "./ErrorText.module.scss";

const ErrorText = ({ children, className, blackError }) => {
  if (children) {
    return (
      <p
        className={`${styles.error_text} ${className || ""} ${
          blackError ? "blackError" : ""
        }`}
      >
        {children}
      </p>
    );
  } else {
    return null;
  }
};

export default ErrorText;
